const features = [
    {
        "id":1,
        "name":"Multichannel Recognition ",
        "content":"Recognition of distinct channels while transcripting  i.e video conferencing etc and annotate the transcripts"
    },
    {
        "id":2,
        "name":"Auto Detect Language ",
        "content":"With Google’s auto detect feature there is no hassle of manually selecting languages "
    },
    {
        "id":3,
        "name":"Automatic Punctuation ",
        "content":"Accurate and automatic punctuation of annotated transcripts"
    },
    {
        "id":4,
        "name":"Speaker Diarization ",
        "content":"Recognition of different users and their distinct voice Identification"
    }
    
    
];

export default features;